import React, { useEffect, useState, useRef } from "react";
import "./Tabs.scss";
import { useNavigate } from "react-router";
import Select from "react-select";
import { customStyles } from "../MobileTabs/customstyle";

const Tabs = ({
  items,
  active,
  setActive,
  isMobileSize = 769,
  variant = "horizontal",
}) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= isMobileSize);
  const [sliderStyles, setSliderStyles] = useState({
    width: 0,
    left: 0,
    height: 0,
    top: 0,
  });
  const tabsRef = useRef(null);

  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= isMobileSize);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobileSize]);

  // Update slider position and size based on active tab
  useEffect(() => {
    if (!isMobile && tabsRef.current) {
      const activeTab = tabsRef.current.querySelector(".tab.isActive");
      if (activeTab) {
        if (variant === "vertical") {
          const { offsetHeight, offsetTop } = activeTab;
          setSliderStyles({
            height: offsetHeight,
            top: offsetTop,
            width: "100%",
            left: 0,
          });
        } else {
          const { offsetWidth, offsetLeft } = activeTab;
          setSliderStyles({
            width: offsetWidth,
            left: offsetLeft,
            height: "100%",
            top: 0,
          });
        }
      }
    }
  }, [active, isMobile, items]);

  // Handle mobile select change
  const handleMobileTabChange = (selectedOption) => {
    setActive(selectedOption.value);
    const selectedItem = items.find(
      (item) => item.value === selectedOption.value
    );
    if (selectedItem?.path) {
      navigate(selectedItem.path);
    }
  };

  return (
    <div
      className={`tabs-main-container ${variant} ${isMobile ? "true" : ""}`}
      style={{ "--tab-count": items.length }}
    >
      {isMobile ? (
        <div className="mobileTabContainer">
          <div className="mobileTabWrapper">
            <Select
              name="tabs"
              id="tabs"
              className="mobileTab"
              classNamePrefix="react-select"
              options={items}
              styles={customStyles(49)}
              isSearchable={false}
              value={items.find((item) => item?.value === active)}
              onChange={handleMobileTabChange}
              placeholder="Select your option"
              formatOptionLabel={({ label, icon }) => (
                <div className="mobile-tab-option">
                  {icon && <span className="mobile-tab-icon">{icon}</span>}
                  <span>{label}</span>
                </div>
              )}
            />
          </div>
        </div>
      ) : (
        <div className="tabs" ref={tabsRef}>
          {items.map((item) => (
            <p
              key={item.value}
              className={`tab ${active === item.value ? "isActive" : ""}`}
              onClick={() => {
                if (item.path) navigate(item.path);
                setActive(item.value);
              }}
              role="tab"
              aria-selected={active === item.value}
              aria-controls={`panel-${item.value}`}
            >
              <span>{item?.icon}</span> <span>{item.label}</span>
            </p>
          ))}
          <div
            className="slider"
            style={
              variant === "vertical"
                ? {
                    height: `${sliderStyles.height}px`,
                    top: `${sliderStyles.top}px`,
                    width: "100%",
                  }
                : {
                    width: `${sliderStyles.width}px`,
                    transform: `translateX(${sliderStyles.left}px)`,
                    height: "100%",
                  }
            }
          />
        </div>
      )}
    </div>
  );
};

export default Tabs;
